"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const MainPage = () => {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null, "Welcome to botDEV.in's Bots"),
        react_1.default.createElement(react_router_dom_1.Link, { to: "/ribbitroyale" },
            react_1.default.createElement("button", null, "Ribbit Royale")),
        react_1.default.createElement(react_router_dom_1.Link, { to: "/karibbit" },
            react_1.default.createElement("button", null, "Karibbit"))));
};
exports.default = MainPage;
